// @ts-nocheck
import { createStyle } from '@gluestack-style/react';
import { BaseIconVariants } from './Icon';

export const RadioIcon = createStyle({
  variants: BaseIconVariants,
  borderRadius: '$full',
  ':checked': {
    color: '$primary600',
    ':hover': {
      color: '$primary700',
      ':disabled': {
        color: '$primary600',
      },
    },
  },
  _dark: {
    ':checked': {
      color: '$primary500',
      ':disabled': {
        color: '$primary500',
      },
      ':hover': {
        ':disabled': {
          color: '$primary500',
        },
        color: '$primary400',
      },
    },
  },
});
